import { db } from "./db";

function normalizeText(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

function includesText(value, search) {
  return normalizeText(value).includes(normalizeText(search));
}

function toNumber(value) {
  const number = Number(value);
  return Number.isNaN(number) ? 0 : number;
}

export async function buscarProductosOffline(search = "", limit = 50) {
  const productos = await db.productos.toArray();
  const term = normalizeText(search);

  const resultado = productos.filter((producto) => {
    if (!term) return true;

    return (
      includesText(producto.codigo, term) ||
      includesText(producto.descripcion, term)
    );
  });

  return resultado.slice(0, limit || resultado.length);
}

export async function buscarClientesOffline(search = "", limit = 50) {
  const clientes = await db.clientes.toArray();
  const term = normalizeText(search);

  return clientes
    .filter((cliente) => {
      if (!term) return true;

      return (
        includesText(cliente.codigo, term) ||
        includesText(cliente.rut, term) ||
        includesText(cliente.razon_social, term) ||
        includesText(cliente.direccion, term) ||
        includesText(cliente.vendedor, term)
      );
    })
    .slice(0, limit);
}

export async function obtenerPrecioOffline(listaPrecio, articulo) {
  const precios = await db.precios
    .where("lista_precio")
    .equals(String(listaPrecio))
    .toArray();

  const precio = precios.find(
    (item) => String(item.articulo) === String(articulo),
  );

  return precio || null;
}

export async function obtenerStockOffline(almacen, articulo) {
  const stocks = await db.stock
    .where("almacen")
    .equals(String(almacen))
    .toArray();

  const stock = stocks.find(
    (item) => String(item.articulo) === String(articulo),
  );

  return stock || null;
}

export async function obtenerStockTotalOffline(almacen, articulo) {
  const stock = await obtenerStockOffline(almacen, articulo);

  if (!stock) return 0;

  return (
    toNumber(stock.stock1) +
    toNumber(stock.stock2) +
    toNumber(stock.stock3) +
    toNumber(stock.stock4) +
    toNumber(stock.stock5)
  );
}

export async function listarAlmacenesOffline() {
  return db.almacenes.toArray();
}

export async function listarListasPreciosOffline() {
  return db.lista_precios.toArray();
}

export async function listarCondicionesPagoOffline() {
  return db.condicion_pagos.toArray();
}

export async function buscarContactosPorClienteOffline(codigoCliente) {
  const codigo = String(codigoCliente || "");

  const contactos = await db.contactos.toArray();

  return contactos.filter((contacto) => {
    return String(contacto.codigo || "") === codigo;
  });
}

export async function obtenerClienteOffline(codigoCliente) {
  const clientes = await db.clientes
    .where("codigo")
    .equals(String(codigoCliente))
    .toArray();

  return clientes[0] || null;
}

export async function obtenerProductoOffline(codigoProducto) {
  const productos = await db.productos
    .where("codigo")
    .equals(String(codigoProducto))
    .toArray();

  return productos[0] || null;
}

export async function obtenerDatoClienteOffline(codigoCliente) {
  const codigo = String(codigoCliente || "");

  let datos = await db.dato_clientes.where("codigo").equals(codigo).toArray();

  if (datos.length === 0 && /^\d+$/.test(codigo)) {
    const codigoConCeros = codigo.padStart(10, "0");

    datos = await db.dato_clientes
      .where("codigo")
      .equals(codigoConCeros)
      .toArray();
  }

  return datos[0] || null;
}

export async function buscarObrasPorClienteOffline(codigoCliente) {
  return db.obras.where("codigo").equals(String(codigoCliente)).toArray();
}

export async function buscarDeudaClienteOffline(codigoCliente) {
  return db.deuda_clientes
    .where("codigo")
    .equals(String(codigoCliente))
    .toArray();
}

export async function listarEstadosOffline() {
  return db.estados.toArray();
}

export async function listarValidezsOffline() {
  return db.validezs.toArray();
}

export async function listarProyectosOffline() {
  // Por ahora no tenemos endpoint sincronizado de proyectos.
  // Lo dejamos vacío para no inventar datos.
  return [];
}
